import DescriptionBanner from "./DescriptionBanner";

export default DescriptionBanner;
